<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/empresa/pesquisas'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para a listagem de pesquisas"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir todas as versões da pesquisa cadastradas
              até o momento. Toda nova versão gerada para a pesquisa aparecerá
              automaticamente na tabela abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-4">
          <div
            class="card shadow flex-grow-1 vld-parent"
            ref="satisfaction_survey"
          >
            <div class="card-body text-center">
              <h1 class="card-title mb-1 text-warning">
                {{ pesquisa.title }}
              </h1>
              <p
                class="description mb-0"
                v-tooltip.bottom="'Início da pesquisa'"
              >
                <i class="fas fa-calendar mr-2" />{{
                  formatDate(pesquisa.start_date)
                }}
              </p>
              <p
                class="description mb-0 font-weight-bold"
                v-tooltip.bottom="'Periodicidade da pesquisa'"
              >
                <i class="fas fa-sync-alt mr-2" />a cada
                {{ pesquisa.frequency }}
                dias
              </p>
              <p class="description mb-0">
                {{ pesquisa.objective_question }}
              </p>
            </div>
            <div class="card-footer text-center">
              <router-link
                :to="{
                  name: 'empresa_pesquisas_edit',
                  params: {
                    returnToVersions: true,
                    pesquisaId: pesquisa.id
                  }
                }"
                class="btn btn-white py-1 px-2"
                v-tooltip="'Editar pesquisa'"
                ><i class="fas fa-edit text-info"></i
              ></router-link>
            </div>
          </div>
        </div>
        <div class="col-xl-8">
          <div
            class="card shadow table-container vld-parent"
            ref="versoes_pesquisa_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    <i class="fas fa-clipboard-list mr-2"></i> Versões da
                    pesquisa
                    <span class="text-warning">{{ pesquisa.title }}</span>
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="tableData"
                type="hover"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Status</th>
                  <th>Title</th>
                  <th>Data de início</th>
                  <th>Data de término</th>
                  <th>Total de respostas</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td class="py-0">{{ index + 1 }}</td>
                  <td>
                    <div>
                      <badge v-if="isActive(row.end_date)" type="success">
                        Ativa
                      </badge>
                      <badge v-else type="warning"> Inativa </badge>
                    </div>
                  </td>
                  <td>
                    {{ row.title }}
                  </td>
                  <td>
                    {{ formatDate(row.start_date, "LL") }}
                  </td>
                  <td>
                    {{ formatDate(row.end_date, "LL") }}
                  </td>
                  <td>
                    {{ row.answered || 0 }}
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'empresa_respostas_versao',
                        params: {
                          pesquisaId: pesquisa.id,
                          id: row.id,
                          returnToVersions: true
                        }
                      }"
                      v-tooltip.bottom="'Visualizar respostas'"
                      class="btn btn-white cursor-pointer py-1 px-2"
                    >
                      <i class="far fa-chart-bar text-primary"></i>
                    </router-link>
                    <span
                      v-tooltip.bottom="
                        isActive(row.end_date)
                          ? 'Editar versão'
                          : 'A pesquisa está encerrada. Para fins de registro, não é possível alterar'
                      "
                      class="mr-2"
                    >
                      <router-link
                        :to="
                          `/empresa/pesquisas/${pesquisa.id}/versoes/${row.id}/editar`
                        "
                        class="btn btn-white cursor-pointer py-1 px-2"
                        :class="{ disabled: !isActive(row.end_date) }"
                      >
                        <i class="fas fa-edit text-info"></i>
                      </router-link>
                    </span>
                    <span
                      v-tooltip.bottom="'Remover versão'"
                      class="btn btn-white cursor-pointer py-1 px-2"
                      @click="handleOpenModalRemove(row)"
                    >
                      <i class="fas fa-trash text-danger"></i>
                    </span>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Não há versões geradas para essa pesquisa até o momento
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!empty" class="row">
        <div class="col-12 text-muted text-right mt-3">
          <b>{{ tableData.length }}</b> versões da pesquisa geradas ao total
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalRemove.show"
      modal-classes="modal-default modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="pb-3 pt-0 text-center">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja
            <span class="text-danger"
              >excluir a versão da pesquisa de satisfação</span
            >, do período de<span class="text-danger">{{
              " " + modalRemove.version.start_date + " "
            }}</span
            >a
            <span class="text-danger">{{ modalRemove.version.end_date }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Ao confirmar, esta versão da pesquisa
            <span class="font-weight-bold">{{ pesquisa.title }}</span
            >, bem como as respostas submetidas a ela serão removidas.
          </p>
        </div>
        <div class="col-12 text-center mt-3" v-if="modalRemove.error">
          <base-alert type="danger"
            >Ocorreu um erro ao remover a versão da pesquisa. Tente
            novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="l-auto"
          @click="modalRemove.show = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          class="text-danger"
          @click="handleRemoveSatisfactionSurvey()"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";
import moment from "moment";

export default {
  name: "versoes_pesquisa_table",
  data() {
    return {
      tableData: [],
      empty: false,
      pesquisa: {},
      modalRemove: {
        show: false,
        version: "",
        error: ""
      }
    };
  },
  async mounted() {
    await this.loadSurveyVersions();
    await this.loadSatisfactionSurvey();
  },
  methods: {
    handleOpenModalRemove(version) {
      this.modalRemove.version = version;
      this.modalRemove.error = "";
      this.modalRemove.show = true;
    },
    async loadSurveyVersions() {
      const loader = this.$loading.show({
        container: this.$refs.versoes_pesquisa_table,
        width: 90,
        height: 90
      });
      try {
        const { data } = await api.get(
          `/company/satisfaction-survey/versions/${this.$route.params.id}`
        );
        if (data.length) this.tableData = data;
        else {
          this.tableData = [];
          this.empty = true;
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as versões da pesquisa"
        );
      }
    },
    async loadSatisfactionSurvey() {
      const loader = this.$loading.show({
        container: this.$refs.satisfaction_survey,
        width: 150,
        height: 150,
        opacity: 0
      });
      try {
        const { data } = await api.get(
          `/company/satisfaction-survey/${this.$route.params.id}`
        );
        if (data) this.pesquisa = data;
        else this.empty = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as pesquisas da empresa"
        );
      }
    },
    async handleRemoveSatisfactionSurvey() {
      this.modalRemove.error = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0
      });
      try {
        await api.delete(
          `/company/satisfaction-survey/version/${this.modalRemove.version.id}`
        );
        this.modalRemove.show = false;
        this.$toasted.show("Versão removida com sucesso");
        await this.loadSurveyVersions();
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao remover a versão pesquisa de satisfação"
        );
        this.modalRemove.error = true;
      } finally {
        loader.hide();
      }
    },
    isActive(end_date) {
      if (moment(end_date).isSameOrAfter(moment())) return true;
      else return false;
    }
  }
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
